import { PropTypes } from 'prop-types';
import { Fragment, default as React, useState } from 'react';
import { FormattedDate, useIntl } from 'react-intl';
import AccionaIcon from '../AccionaIcon';
import { getValue } from '../../utils/utils';

const AccionaTableBody = ({
  bodyData,
  onClickCheckBox,
  selectedRows,
  columns,
  actions,
  pageSize,
  expandable,
  isSelectionDisabled,
  rowHeight,
}) => {
  const intl = useIntl();
  const [expandedRows, setExpandedRows] = useState(new Set());

  return (
    <tbody id="AccionaTableBody">
      {bodyData.slice(0, pageSize).map((x, index) => {
        const classContainerButtons = {
          minWidth: '140px',
          padding: '10px 6px',
          height: rowHeight,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        };
        return (
          <Fragment key={`${index}.row`}>
            <tr key={`${index}.row`} id={`${index}.row`}>
              {expandable && (
                <td
                  key={`${index}.expandable}`}
                  id={`${index}.expandable`}
                  width="80px"
                >
                  {expandable?.rowExpandable(x) ? (
                    <div style={{ width: '100%', textAlign: 'center' }}>
                      <AccionaIcon
                        id={`${index}.viewSelect`}
                        className="btn btn-darkgray"
                        classIcon={`icon fas ${
                          expandedRows.has(x.id) ? 'fa-minus' : 'fa-plus'
                        }`}
                        onClick={() => {
                          setExpandedRows((prev) => {
                            const newExpanded = new Set(prev);
                            if (newExpanded.has(x.id)) {
                              newExpanded.delete(x.id);
                            } else {
                              newExpanded.add(x.id);
                            }
                            return newExpanded;
                          });
                        }}
                      />
                    </div>
                  ) : null}
                </td>
              )}
              {Object.keys(columns).map((y) => {
                if (columns[y].isDate) {
                  return (
                    <td
                      key={`${index}.${y}`}
                      id={`${index}.${y}`}
                      align={columns[y].align}
                    >
                      <FormattedDate value={x[y]} />
                    </td>
                  );
                } else {
                  if (columns[y].render) {
                    return columns[y].render(x[y]);
                  } else if (x[y] !== undefined || x[y] !== null) {
                    var valueRow = getValue(y, x);
                    if (columns[y].isVisible === false) return null;
                    if (columns[y].translatable)
                      valueRow = intl.formatMessage({ id: x[y] });
                    return (
                      <td
                        key={`${index}.${y}`}
                        id={`${index}.${y}`}
                        align={columns[y].align}
                      >
                        {' '}
                        {valueRow}
                      </td>
                    );
                  } else
                    return <td key={`${index}.${y}`} id={`${index}.${y}`}></td>;
                }
              })}
              {actions && (
                <td
                  id={`${index}.actions`}
                  key={`${index}.actions`}
                  style={classContainerButtons}
                >
                  {actions(x)}
                </td>
              )}
              {onClickCheckBox && (
                <td
                  id={`${index}.checkbox`}
                  key={`${index}.checkbox`}
                  style={{ textAlign: 'center' }}
                >
                  <input
                    key={`${index}.checkbox.input`}
                    type="Checkbox"
                    disabled={isSelectionDisabled(x)}
                    checked={selectedRows.some((row) => row.id === x.id)}
                    onChange={({ target }) => {
                      onClickCheckBox(target.checked, x);
                    }}
                  />
                </td>
              )}
            </tr>
            {expandable?.rowExpandable(x) &&
              expandedRows.has(x.id) &&
              expandable.expandedRowRender(x)}
          </Fragment>
        );
      })}
    </tbody>
  );
};

AccionaTableBody.propTypes = {
  bodyData: PropTypes.arrayOf(PropTypes.object),
  columnsName: PropTypes.arrayOf(PropTypes.string),
  dateRows: PropTypes.arrayOf(PropTypes.string),
  deleteAction: PropTypes.func,
  editAction: PropTypes.func,
  viewAction: PropTypes.func,
  onClickCheckBox: PropTypes.func,
  hiddenCheckBox: PropTypes.bool,
  eheAction: PropTypes.func,
  preRegisteredAction: PropTypes.func,
  deletePreregisterAction: PropTypes.func,
  selectedRows: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.object,
  buttons: PropTypes.object,
  actions: PropTypes.func,
  pageSize: PropTypes.number,
  expandable: PropTypes.shape({
    rowExpandable: PropTypes.func,
    expandedRowRender: PropTypes.func,
  }),
  isSelectionDisabled: PropTypes.func,
  rowHeight: PropTypes.string,
};

AccionaTableBody.defaultProps = {
  bodyData: [],
  columnsName: [],
  dateRows: [],
  deleteAction: undefined,
  editAction: undefined,
  viewAction: undefined,
  onClickCheckBox: undefined,
  hiddenCheckBox: true,
  eheAction: undefined,
  preRegisteredAction: undefined,
  deletePreregisterAction: undefined,
  selectedRows: [],
  columns: {},
  buttons: {},
  actions: undefined,
  entity: '',
  pageSize: 5,
  expandable: undefined,
  isSelectionDisabled: () => false,
  rowHeight: '94px',
};

export default AccionaTableBody;
